// initial state
const state = {
  sheets: [],
  metadata: {},
  status: null,
  orphanSheetsLoading: false,
  orphanSheets: [],
  orphanSheetsMeta: {},
};

const mutations = {
  setSheets(currentState, sheets) {
    currentState.sheets = sheets;
  },
  // setClientSheets(currentState, newSheets) {
  //   currentState.sheets = currentState.sheets
  //     .filter(obj => newSheets.indexOf(obj) === -1);
  //   currentState.push(...newSheets);
  // },
  setMetadata(currentState, { key, params }) {
    const { size, start, count } = params;
    const newMeta = {};
    newMeta[key] = { size, start, count };
    currentState.metadata = Object.assign(newMeta);
  },
  setOrphanSheets(currentState, values) {
    currentState.orphanSheets = values;
  },
  setOrphanSheetsMeta(currentState, value) {
    currentState.orphanSheetsMeta = value;
  },
  setOrphanSheetsLoading(currentState, value) {
    currentState.orphanSheetsLoading = value;
  },
};

export { mutations, state };
